import { extractJsonFieldSql } from './extractJsonFieldSql';
import { DesignEnum } from '../enums/DesignEnum';
import { LocalesEnum } from '../enums/LocalesEnum';
const Square45Value = `%%${JSON.stringify('Square45')}%%`;
const SquareValue = `%%${JSON.stringify('Square')}%%`;
const RotaryWedgeGrooveValue = `%%${JSON.stringify('RotaryWedgeGroove')}%%`;
const RotaryFlatHeadValue = `%%${JSON.stringify('RotaryFlatHead')}%%`;
const GlobeValveValue = `%%${JSON.stringify(['GlobeValve'])}%%`;
const ShortStrokeGlobeValve = `%%${JSON.stringify(['ShortStrokeGlobeValve'])}%%`;
export function buildFBDFilter(design: DesignEnum, rawName: LocalesEnum): [string, string[]] {
  switch (design) {
    case DesignEnum.Square45: {
      return [
        `${extractJsonFieldSql('attributes', `$.1024.${rawName}`)} LIKE ?`,
        [Square45Value]
      ]
    }
    case DesignEnum.Square: {
      return [
        `${extractJsonFieldSql('attributes', `$.1024.${rawName}`)} LIKE ?`,
        [SquareValue]
      ]
    }
    case DesignEnum.RotaryWedgeGroove: {
      return [
        `${extractJsonFieldSql('attributes', `$.1024.${rawName}`)} LIKE ?`,
        [RotaryWedgeGrooveValue]
      ]
    }
    case DesignEnum.RotaryFlatHead: {
      return [
        `${extractJsonFieldSql('attributes', `$.1024.${rawName}`)} LIKE ?`,
        [RotaryFlatHeadValue]
      ]
    }
    case DesignEnum.GlobeValve: {
      return [
        `${extractJsonFieldSql('attributes', `$.1024.${rawName}`)} LIKE ?`,
        [GlobeValveValue]
      ]
    }
    case DesignEnum.ShortStrokeGlobeValve: {
      return [
        `${extractJsonFieldSql('attributes', `$.1024.${rawName}`)} LIKE ?`,
        [ShortStrokeGlobeValve]
      ]
    }
    default:
      throw new Error(`Unknown Design Type ${design}`);
  }
}
